import { render, staticRenderFns } from "./list-assets.vue?vue&type=template&id=f136aa9c&scoped=true&"
import script from "./list-assets.vue?vue&type=script&lang=ts&"
export * from "./list-assets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f136aa9c",
  null
  
)

export default component.exports